import axios from 'axios';
// require('dotenv').config();
import config from '../src/config/common';

const BASE = `${config.API_URL}api/sales`;
const bust = () => `_t=${Date.now()}`;

const toLocalISO = (dateStr) => {
  if (!dateStr) return dateStr;
  const [y, m, d] = dateStr.split('-');
  const dt = new Date(+y, +m - 1, +d);
  return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`;
};

const get = (url) => axios.get(url).then(r => r.data);

export const api = {
  kpi:           (s, e) => get(`${BASE}/kpi?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  daily:         (s, e) => get(`${BASE}/daily?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  products:      (s, e) => get(`${BASE}/products?start=${toLocalISO(s)}&end=${toLocalISO(e)}&limit=100000&${bust()}`),
  states:        (s, e) => get(`${BASE}/states?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  paymode:       (s, e) => get(`${BASE}/paymode?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  partytype:     (s, e) => get(`${BASE}/partytype?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  customers:     (s, e) => get(`${BASE}/customers?start=${toLocalISO(s)}&end=${toLocalISO(e)}&limit=100000&${bust()}`),
  transactions:  (s, e, page = 1) => get(`${BASE}/transactions?start=${toLocalISO(s)}&end=${toLocalISO(e)}&page=${page}&${bust()}`),
  paymentReport: (s, e) => get(`${BASE}/payment-report?start=${toLocalISO(s)}&end=${toLocalISO(e)}&${bust()}`),
  download:      (s, e) => window.open(`${BASE}/download?start=${toLocalISO(s)}&end=${toLocalISO(e)}`, '_blank'),
  triggerReport: (date)  => axios.post(`${BASE}/trigger-report`, { date }).then(r => r.data),
  refreshCache:  ()      => axios.post(`${BASE}/refresh-cache`).then(r => r.data),
  productStates: (s, e, product) =>get(`${BASE}/product-states?start=${toLocalISO(s)}&end=${toLocalISO(e)}&product=${encodeURIComponent(product)}&${bust()}`),
  productUnsold: (s, e, product) =>get(`${BASE}/product-unsold?start=${toLocalISO(s)}&end=${toLocalISO(e)}&product=${encodeURIComponent(product)}&${bust()}`),
  stateProducts: (s, e, state) =>
  get(`${BASE}/state-products?start=${toLocalISO(s)}&end=${toLocalISO(e)}&state=${encodeURIComponent(state)}&${bust()}`),
  customerProducts: (s, e, customerId) =>
  get(`${BASE}/customer-products?start=${toLocalISO(s)}&end=${toLocalISO(e)}&customerId=${encodeURIComponent(customerId)}&${bust()}`),
};
